import classes from "../../CriteriaSubmission/criteriaSubmission.module.css";
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import util from "../../../styles/utilities.module.css"; // Phase3: standardized button utilities


const FileUploader = ( {nameInStore, selectStoreData, setStoreData, instance, showInfoText=true} ) => {
  const storeData = useSelector(selectStoreData);
  const dispatch = useDispatch();
  const qtyName = nameInStore + "_qty";

  const [files, setFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [maxFiles, setMaxFiles] = useState(10);
  
  const fileInputRef = useRef(null);

  // Effect to synchronize the internal state with the store's state on component mount and whenever the store's state changes
  useEffect(() => {
    if (storeData && storeData[nameInStore]) {
      setFiles(storeData[nameInStore]);
    } else {
      setFiles([]);
    }
  }, [storeData, nameInStore]);

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    let totalSize = 0;
    if (selectedFiles.length > maxFiles) {
      setErrorMessage(`You can only upload up to ${maxFiles} files.`);
      return;
    }

    const newFiles = [...files, ...Array.from(selectedFiles)];
    for (let i = 0; i < newFiles.length; i++) {
      totalSize += newFiles[i].size;
    }
    if (totalSize > 30 * 1024 * 1024) {
      setErrorMessage("Total size of files exceeds 30MB.");
      return;
    }
    setErrorMessage("");
    setMaxFiles(maxFiles - selectedFiles.length);
    setFiles(newFiles);
    dispatch(
      setStoreData({
        [nameInStore]: newFiles,
        [qtyName]: newFiles.length,
      })
    );
    e.target.value = "";
  };

  const removeFile = (file) => {
    const newFiles = files.filter((f) => {
      return f !== file;
    });
    setFiles(newFiles);
    dispatch(
      setStoreData({
        [nameInStore]: newFiles,
        [qtyName]: newFiles.length,
      })
    );

    setMaxFiles(10 - newFiles.length);
  };
  return (
    <div className={`${classes.hideFileIcon} `}>
      <input
        ref={fileInputRef} // Attach the ref to the input
        /* Hidden input: border removed (not visible); Phase 2 tokenization */
        style={{ display: "none" }}
        type="file"
        id={"123Img"+instance}
        name={"123Img"+instance}
        multiple
        onChange={handleFileChange}
        accept="image/*,application/pdf"
        aria-label="Upload file"
        className="border hidden"
      />

      <div>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {/* Phase3: replace bespoke span uploadButton with semantic button using utility styles */}
            <button
              type="button"
              className={`${util.btn} ${util['btn--secondary']} ${util['my-4']}`}
              style={{ boxShadow: 'var(--shadow-md)' }}
              onClick={(e) => {
                // Delegate click to hidden file input
                e.preventDefault();
                if (fileInputRef.current) fileInputRef.current.click();
              }}
            >
              Upload file
            </button>
            {showInfoText ? (
              <div style={{ textAlign: "start" }}>
                <p className={classes.formLabel} style={{ fontWeight: "var(--font-weight-semibold)", paddingTop: 0, marginBottom: 0 }}>(.pdf, .PNG, .JPEG - max. of 10 files, 30MB total)</p>
              </div>
            ) : null}
          </div>
        </div>
        {errorMessage ? (
          <p
            style={{
              color: "var(--color-danger)",
              textAlign: "left",
              fontWeight: "var(--font-weight-semibold)",
            }}
          >
            {errorMessage}
          </p>
        ) : null}
        {files?.length > 0 ? (
          <div
            style={{
              textAlign: "left",
            }}
          >
            <h4
              style={{
                fontWeight: "var(--font-weight-semibold)",
                paddingBottom: "10px",
              }}
            >
              Uploaded files:
            </h4>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {files?.map((file, index) => {
                return (
                  <div
                    key={`${file.name}${index}`}
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <span>{`${index + 1}) `}</span>
                      <span>{file.name}</span>
                    </div>
                    <button
                      type="button"
                      onClick={() => removeFile(file)}
                      className={`${util.btn} ${util['btn--ghost']} ${util['btn-xs']}`}
                      style={{ padding: '2px 8px' }}
                      aria-label={`Remove file ${file.name}`}
                    >
                      Remove
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FileUploader;
